<div class="smiley-rating">
  <div class="smiley-rating__label">How did you like this episode?</div>
  <div class="smiley-rating__buttons">
    <button
      *ngFor="let emoji of emojis; let i = index"
      class="smiley-rating__btn"
      [class.smiley-rating__btn--selected]="selectedRating === i + 1"
      [disabled]="isSubmitting"
      (click)="onRatingClick(i + 1)"
      [attr.aria-label]="'Rate ' + (i + 1) + ' out of 5'">
      {{ emoji }}
    </button>
  </div>
  <div *ngIf="hasRated && !submitError" class="smiley-rating__success">
    Thank you for your rating!
  </div>
  <div *ngIf="submitError" class="smiley-rating__error">
    Something went wrong. Please try again.
  </div>
</div>
